import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  POWERBI_POST_FAILURE: 'POWERBI_POST_FAILURE',
  POWERBI_POST_REQUEST: 'POWERBI_POST_REQUEST',
  POWERBI_POST_SUCCESS: 'POWERBI_POST_SUCCESS',
};

export const actionCreators = {
  postRequest: (pbiPost: any) => ({
    type: actionTypes.POWERBI_POST_REQUEST,
    payload: pbiPost,
    [WAIT_FOR_ACTION]: actionTypes.POWERBI_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.POWERBI_POST_FAILURE,
  }),
  postSuccess: (accessToken: any) => ({
    type: actionTypes.POWERBI_POST_SUCCESS,
    payload: accessToken,
  }),
  postFailure: (error: Error) => ({
    type: actionTypes.POWERBI_POST_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};